import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

type Currency = {
    Id: number;
    Name: string;
    Code: string;
    DisplaySign: string;
    DecimalPlaces: string;
    PlayForFunDefaultValue: number;
};

export interface AddCurrencyPagePageOptions extends PageOptionsBase {
    currenciesMap: { [id: number]: Currency };
}

export class AddCurrencyPage extends PageBase<AddCurrencyPagePageOptions> {
    private ddCurrency: JQuery;
    private txtCurrencyName: JQuery;
    private txtDefaultDisplaySign: JQuery;
    private txtDefaultDecimalPlaces: JQuery;
    private inputPlayForFunAmount: JQuery;


    constructor(options: AddCurrencyPagePageOptions) {
        super(options);

        this.onCurrencyChange = this.onCurrencyChange.bind(this);
    }

    init(): void {
        this.ddCurrency = $('#currency');
        this.ddCurrency.on('change', this.onCurrencyChange);

        this.txtCurrencyName = $('#txtCurrencyName');
        this.txtDefaultDisplaySign = $('#txtDefaultDisplaySign');
        this.txtDefaultDecimalPlaces = $('#txtDefaultDecimalPlaces');
        this.inputPlayForFunAmount = $('#PlayForFunAmount');
        this.onCurrencyChange();
    }

    private onCurrencyChange(): void {
        var selectedItem = this.ddCurrency.find(':selected');
        var currencyId = parseInt(selectedItem.val());
        if (!isNaN(currencyId)) {
            var currency = this._options.currenciesMap[currencyId];
            if (currency) {
                this.txtCurrencyName.text(currency.Name);

                if (Utils.isNullOrUndefined(currency.DisplaySign)) {
                    this.txtDefaultDisplaySign.text("");
                } else {
                    this.txtDefaultDisplaySign.text(currency.DisplaySign);
                }

                if (Utils.isNullOrUndefined(currency.DecimalPlaces)) {
                    this.txtDefaultDecimalPlaces.text("");
                } else {
                    this.txtDefaultDecimalPlaces.text(currency.DecimalPlaces);
                }

                if (Utils.isNullOrUndefined(currency.PlayForFunDefaultValue)) {
                    this.inputPlayForFunAmount.val("");
                } else {
                    this.inputPlayForFunAmount.val(currency.PlayForFunDefaultValue)
                }
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/AddCurrencyPage.ts
 **/